import request from '../../request/http'
//登录
export function login(data){
    return request({
        url: '/iam/auth/login' ,
        method: 'post',
        data: data
    })
}
//退出登录
export function Logout(){
    return request({
        url: '/iam/auth/logout' ,
        method: 'post',
    })
}
//修改密码
export function changePwd(data){
    return request({
        url: '/iam/account/updPassword' ,
        method: 'post',
        data: data
    })
}
//刷新token
export function GetRefreshToken(data) {
    return request({
        url: '/iam/auth/refreshToken',
        method: "post",
        data,
        headers: {'Content-Type': 'application/json;charset=UTF-8'}
    })
}
//根据应用编码获取应用详情
export function QueryAppDetail(data) {
    return request({
        url: '/iam/app/getAppByCode',
        method: "post",
        data,
    })
}
//获取当前用户资源权限
export function QueryResource(data){
    return request({
        url: "/iam/AuthResource/getUserPermissions",
        method: "post",
        data,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
}
//获取手机验证码
export function QueryPhoneCode(data) {
    return request({
        url: '/iam/auth/getPhoneCaptcha',
        method: "post",
        data,
    })
}
//获取图片验证码
export function QueryImgCode(data) {
    return request({
        url: '/iam/auth/getImgCaptcha',
        method: "post",
        data
    })
}
//通过验证码获取手机验证码
export function QueryCode(data) {
    return request({
        url: '/iam/auth/getPhoneCaptchaByCaptcha',
        method: "post",
        data
    })
}
//验证码账号登录
export function CaptchaLogin(data) {
    return request({
        url: '/iam/auth/captchaLogin',
        method: "post",
        data
    })
}
//手机号登录
export function PhoneLogin(data) {
    return request({
        url: '/iam/auth/phoneLogin',
        method: "post",
        data
    })
}
//重置密码 手机号验证码
export function ReplacePassword(data) {
    return request({
        url: '/iam/account/resetPwd',
        method: "post",
        data
    })
}
/**获取企业微信的配置 */
export function GetWechatConfig() {
    return request({
        url: '/iam/auth/getWechatConfig',
        method: "get",
    })
}
/**企业微信登录 */
export function WechatLogin(data) {
    return request({
        url: '/iam/auth/wechatLogin',
        method: "post",
        data
    })
}